import clsx from 'clsx';
import { TextField } from '../../../../../../shared/ui/textfield';
import { IconButton } from '../../../../../../shared/ui/icon-button';
import { AddRowButton } from '../../../../../../shared/ui/add-row-button';
import { TrashMutedIcon } from '../../../../../../shared/ui/icons';
import styles from '../BasicInformationCard.module.css';

export function SubjectsField({
  subjects,
  onSetSubjectAt,
  onRemoveSubjectAt,
  onAddSubject,
  canAddNextSubject,
  subjectErrors = [],
}) {
  return (
    <div className={clsx(styles.subjectsGroup)}>
      <div className={clsx(styles.fieldGroup)}>
        <div className={clsx(styles.label)}>Email Subject Lines</div>
        <div className={clsx(styles.subjectsList)}>
          {subjects.map((subject, idx) => {
            const error = subjectErrors[idx] ?? {};
            // Required (blocking) takes precedence over the max-length warning; an empty
            // field can't be over-length, so only one shows. Only required lights the field red.
            const message = error.requiredError || error.maxLenError || '';
            const isWarning = !error.requiredError && Boolean(error.maxLenError);
            return (
              <div key={idx} className={clsx(styles.subjectItem)}>
                <div className={clsx(styles.subjectRow)}>
                  <TextField
                    value={subject}
                    onChange={(val) => onSetSubjectAt(idx, val)}
                    placeholder="e.g., Welcome Email - Pre-Charge Off"
                    ariaLabel={`Email Subject Line ${idx + 1}`}
                    variant="form"
                    invalid={Boolean(error.requiredError)}
                    variableTarget
                  />
                  {subjects.length > 1 ? (
                    <IconButton
                      ariaLabel={`Remove email subject line ${idx + 1}`}
                      onClick={() => onRemoveSubjectAt(idx)}
                      size="md"
                    >
                      <TrashMutedIcon className={clsx(styles.trashIcon)} />
                    </IconButton>
                  ) : null}
                </div>
                {message ? (
                  <div
                    className={clsx(isWarning ? styles.warningText : styles.errorText)}
                    data-field-error={isWarning ? undefined : true}
                  >
                    {message}
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>

      <AddRowButton
        label="Add Email Subject Line"
        onClick={onAddSubject}
        disabled={!canAddNextSubject}
      />
    </div>
  );
}
